import React from 'react';
import { debounce } from 'lodash';
import {NumericFormat} from "react-number-format";
import TextFieldMUI from "@mui/material/TextField";
import {formatNumber} from "../../../reducer/actions/formatNumber";
import {formatPrice} from "../../../reducer/actions/formatPrice";

export default function NumberEditCell({
  params,
  column,
}: {
  params: any;
  column: any;
}) {

  const debouncedOnChange = debounce(handleDebouncedOnChange, 0);

  function handleDebouncedOnChange(value: any) {

    let pp = value ? value : 0;

    if (params?.row?.size){
      pp = pp/params?.row?.size;
    }

    if (params?.value?.currency?.id){
      if (params?.value?.currency?.id === 1){
        pp = formatPrice(pp, true, true);
      }
      if (params?.value?.currency?.id === 2){
        pp = formatPrice(pp,false,true);
      }
    }else{
      pp = formatNumber(pp);
    }

    const transformedValue = {
      currency: params?.value?.currency,
      value: value,
      value_pp: pp,
    };

    params.api.setEditCellValue({
      id: params.id,
      field: params.field,
      value: transformedValue,
    });

  }

  return (
    <>
      <NumericFormat
        value={params?.value?.value}
        className={'w-full'}
        thousandSeparator=" "
        customInput={TextFieldMUI}
        size="small"
        variant="outlined"
        sx={{
          '& .MuiOutlinedInput-notchedOutline' : {
            border: 'none'
          }
        }}
        onValueChange={(values) => {
          const { formattedValue, value, floatValue } = values;
          debouncedOnChange(parseFloat(value));
        }}
      />
    </>
  );
}
